import * as React from "react";
const SvgFiRrStreetView = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-street-view_svg__a)">
      <path
        fill="#062147"
        d="M12 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m3 19v-4.171A3.01 3.01 0 0 0 17 12v-2c0-2.206-1.794-4-4-4h-2c-2.206 0-4 1.794-4 4v2c0 1.304.836 2.416 2 2.829V19a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1 1 1 0 0 1-1-1v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 .551-.448 1-1 1a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0m9 .5c0-1.748-2.059-3.138-5.797-3.913a1.001 1.001 0 0 0-.407 1.958c3.145.653 4.203 1.616 4.203 1.955 0 .748-3.402 2.5-10 2.5s-10-1.752-10-2.5c0-.339 1.059-1.302 4.203-1.955a1 1 0 1 0-.407-1.958c-3.738.775-5.797 2.165-5.797 3.913 0 3.092 6.221 4.5 12 4.5s12-1.408 12-4.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-street-view_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStreetView;
